module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/140.e0764af2.png";